<div class="flex items-start w-full relative" [formGroup]="form">
  <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full my-3">
    <textarea
      matInput
      class="mb-8"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="minRows"
      [cdkAutosizeMaxRows]="maxRows"
      [formControlName]="control"
      [placeholder]="placeholderText"
      #generatedTextArea
    ></textarea>
  </mat-form-field>
  <div class="absolute bottom-4 right-2 left-4 flex justify-between items-center">
    <button *ngIf="generatedTextArea.value.trim()" (click)="clearText()"
      class="text-blue-500 underline border-0">Clear</button>
    <ng-container>
      <button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="popoverMenu" matRipple
        class="h-4 w-4 rounded-full ml-auto">
        <mat-icon svgIcon="mat_outline:auto_fix_high" class="icon-size-4"></mat-icon>
      </button>
    </ng-container>
    <!-- <ng-container *ngIf="isLoading">
      <mat-progress-spinner [diameter]="16" [mode]="'indeterminate'" class="ml-auto"></mat-progress-spinner>
    </ng-container> -->
  </div>
</div>

<mat-menu [hasBackdrop]="false" [xPosition]="'before'" #popoverMenu="matMenu">
  <div class="ai-popover" (click)="$event.stopPropagation()">
    <mat-card class="">
      <mat-card-header class="m-0">
        <mat-card-title>AI Assistant</mat-card-title>
        <mat-card-subtitle>Describe your content</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript w-full my-0">
          <textarea
            matInput
            class="mb-8"
            cdkTextareaAutosize
            [cdkAutosizeMinRows]="1"
            [cdkAutosizeMaxRows]="5"
            [(ngModel)]="contentDescriptionText"
            #contentDescription
          ></textarea>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions class="m-0 text-end">
        <button mat-stroked-button class="rounded" (click)="closeMenu()">Cancel</button>
        <button mat-flat-button [disabled]="!contentDescriptionText.trim()" (click)="generateAIText()"
          color="primary" class="rounded ml-2">
          <span *ngIf="!isLoading">Generate</span>
          <span *ngIf="isLoading">Please wait...</span>
          <mat-progress-spinner *ngIf="isLoading" [diameter]="16" [mode]="'indeterminate'"
            class="ml-2"></mat-progress-spinner>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</mat-menu>
